"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.noCredits.message': 'Nie masz wystarczających kredytów, aby korzystać z usługi czatu. Kup więcej kredytów, aby kontynuować.',
};
